import { selectVariant } from '@process-advisor/process-miner/api/methods/slicers/selectVariant';

import { setVariantSlicerSelectedData } from '@process-advisor/process-miner/api/methods/slicers/setVariantSlicerSelectedGridData';
import { updateGauges } from '@process-advisor/process-miner/api/methods/slicers/updateGauges';
import { updateVariantSlicerVariantChart } from '@process-advisor/process-miner/api/methods/slicers/updateVariantSlicerVariantChart';
import { variantsTable } from '@process-advisor/process-miner/api/methods/slicers/variantsTable';
import { stepsTable } from '@process-advisor/process-miner/api/methods/slicers/stepsTable';
import { activitiesTable } from '@process-advisor/process-miner/api/methods/slicers/activitiesTable';
import { saveVariantSlicerGridState } from '@process-advisor/process-miner/api/methods/slicers/saveVariantGridState'
import { saveVariantSlicerGridFilterState } from '@process-advisor/process-miner/api/methods/slicers/saveVariantGridFilterState'
import { showDetailVariants } from '@process-advisor/process-miner/api/methods/slicers/showDetailVariants'
import { setDiscoveryRuleDetailProps} from '@process-advisor/process-miner/api/methods/slicers/setDiscoveryRuleDetailProps'
import { setVariantDetailProps} from '@process-advisor/process-miner/api/methods/slicers/setVariantDetailProps'
import { setTaskID} from '@process-advisor/process-miner/api/methods/slicers/setTaskID'
import { setTaskDetailSelectedData } from '@process-advisor/process-miner/api/methods/slicers/setTaskDetailSelectedGridData';


export const slicersMethods = {
    selectVariant,
    updateVariantSlicerVariantChart,
    setVariantSlicerSelectedData,
    updateGauges,
    variantsTable,
    stepsTable,
    activitiesTable,
    saveVariantSlicerGridState,
    saveVariantSlicerGridFilterState,
    showDetailVariants,
    setVariantDetailProps,
    setTaskID,
    setDiscoveryRuleDetailProps,
    setTaskDetailSelectedData
};


